import axios from 'axios'

const defaultState = {
  fileInfoDetail: [],
  currentFolder: undefined,
  currentModule: undefined,
  currentRecord: undefined,
  currentRecordFolder: undefined,
  currentElement: undefined,
  navigation: undefined,
  isSearching: false,
  browseHistory: [],
  isLoading: true,
  data: [],
  dataPreview: [],
}

const actions = {
  getFolderById: ({ commit, getters, rootGetters }, data) => {
    let url = '/folder-browse/' + data.folder_uid + getters.sorting.URI

    // Prefer the latest backend-issued token from cookie; fall back to Vuex/localStorage
    const cookieToken =
      typeof document !== 'undefined' && document.cookie
        ? decodeURIComponent(
            (document.cookie.match(/(?:^|; )token=([^;]*)/) || [])[1] || '',
          )
        : ''
    const storedToken = rootGetters.token || localStorage.getItem('token') || ''
    const token = cookieToken || storedToken

    const configHeaders = {
      'content-type': 'application/json',
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      ...(token ? { Authorization: 'Bearer ' + token } : {}),
    }

    let apiUrl = rootGetters.api

    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        baseURL: apiUrl,
        headers: configHeaders,
      })
        .then((response) => {
          // request succeeded
          resolve(response) // return response data to calling function
        })
        .catch((error) => {
          // request failed
          reject(error) // return error to calling function
        })
    })
  },
  getFolderByIdAndSetData: ({ commit, getters, rootGetters }, data) => {
    let url = '/folders/' + data.folder_uid + getters.sorting.URI

    const cookieToken =
      typeof document !== 'undefined' && document.cookie
        ? decodeURIComponent(
            (document.cookie.match(/(?:^|; )token=([^;]*)/) || [])[1] || '',
          )
        : ''
    const storedToken = rootGetters.token || localStorage.getItem('token') || ''
    const token = cookieToken || storedToken

    const configHeaders = {
      'content-type': 'application/json',
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      ...(token ? { Authorization: 'Bearer ' + token } : {}),
    }

    let apiUrl = rootGetters.api

    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        baseURL: apiUrl,
        headers: configHeaders,
      })
        .then((response) => {
          // request succeeded
          //commit('GET_FILEINFO_DETAIL', data.item)
          commit('LOADING_STATE_PREVIEW', {
            loading: false,
            dataPreview: response.data,
          })
          //commit('STORE_CURRENT_FOLDER', payload.folder)
          resolve(response) // return response data to calling function
        })
        .catch((error) => {
          //console.log(error)
          // request failed
          reject(error) // return error to calling function
        })
    })
  },
  getFolderByIdAndSetDataForPreview: (
    { commit, getters, rootGetters },
    data,
  ) => {
    let url = '/folders/' + data.folder_uid + getters.sorting.URI

    const cookieToken =
      typeof document !== 'undefined' && document.cookie
        ? decodeURIComponent(
            (document.cookie.match(/(?:^|; )token=([^;]*)/) || [])[1] || '',
          )
        : ''
    const storedToken = rootGetters.token || localStorage.getItem('token') || ''
    const token = cookieToken || storedToken

    const configHeaders = {
      'content-type': 'application/json',
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      ...(token ? { Authorization: 'Bearer ' + token } : {}),
    }

    let apiUrl = rootGetters.api

    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        baseURL: apiUrl,
        headers: configHeaders,
      })
        .then((response) => {
          // Populate preview list without clearing current selection
          commit('LOADING_STATE_PREVIEW', {
            loading: false,
            dataPreview: response.data,
          })
          // Restore selected item in preview context if provided
          if (data && data.item) {
            commit('GET_FILEINFO_DETAIL_PREVIEW', data.item)
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

const mutations = {
  LOADING_STATE(state, payload) {
    state.fileInfoDetail = []
    state.data = payload.data
    state.isLoading = payload.loading
  },
  LOADING_STATE_PREVIEW(state, payload) {
    // Preserve current selection; only update preview dataset and loading flag
    state.dataPreview = payload.dataPreview
    state.isLoading = payload.loading
  },
  ADD_NEW_ITEMS(state, items) {
    state.data = state.data.concat(items)
  },
  CLEAR_FILEINFO_DETAIL(state) {
    state.fileInfoDetail = []
  },
  LOAD_FILEINFO_DETAIL(state, item) {
    state.fileInfoDetail = [item]
  },
  GET_FILEINFO_DETAIL(state, item) {
    let checkData = state.data.find((el) => el.unique_id == item.unique_id)

    if (state.fileInfoDetail.includes(checkData)) return

    state.fileInfoDetail.push(checkData ? checkData : state.currentFolder)
  },
  GET_FILEINFO_DETAIL_PREVIEW(state, item) {
    console.log(
      '[Store] GET_FILEINFO_DETAIL_PREVIEW try',
      item && item.unique_id,
      'dataPreview len',
      state.dataPreview.length,
    )
    let checkData = state.dataPreview.find(
      (el) => el && el.unique_id == (item && item.unique_id),
    )

    // Prefer the object from dataPreview; fallback to passed item; else keep existing
    const resolved = checkData || item || state.currentFolder || null
    if (!resolved) return

    state.fileInfoDetail = [resolved]
    console.log(
      '[Store] fileInfoDetail now',
      state.fileInfoDetail.map((i) => i && i.unique_id),
    )
  },
  REMOVE_ITEM(state, uniqueId) {
    const uid = String(uniqueId)
    // Remove from data array
    state.data = (state.data || []).filter(
      (item) => item && String(item.unique_id) !== uid,
    )
    // Remove from dataPreview array
    state.dataPreview = (state.dataPreview || []).filter(
      (item) => item && String(item.unique_id) !== uid,
    )
    // Remove from fileInfoDetail if present
    state.fileInfoDetail = (state.fileInfoDetail || []).filter(
      (item) => item && String(item.unique_id) !== uid,
    )
  },
}

const getters = {
  fileInfoDetail: (state) => state.fileInfoDetail,
  currentFolder: (state) => state.currentFolder,
  currentModule: (state) => state.currentModule,
  currentRecord: (state) => state.currentRecord,
  currentRecordFolder: (state) => state.currentRecordFolder,
  currentElement: (state) => state.currentElement,
  browseHistory: (state) => state.browseHistory,
  isSearching: (state) => state.isSearching,
  navigation: (state) => state.navigation,
  isLoading: (state) => state.isLoading,
  data: (state) => state.data,
  dataPreview: (state) => state.dataPreview,
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
}
